module.exports = __webpack_public_path__ + "img/plr.51ca6516.svg";